import { Component, Input } from '@angular/core';
import { ProyectosService } from 'src/app/proyectos/proyectos.service';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { Discusion } from 'src/app/shared/model/gestion-proyectos/discusion';
import { HucuService } from '../hucu.service';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { NgIf, NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-dicusiones',
    templateUrl: './dicusiones.component.html',
    styleUrls: ['./dicusiones.component.css'],
    imports: [MatFormField, MatLabel, MatIcon, MatInput, FormsModule, MatButton, NgIf, NgFor, DatePipe]
})
export class DiscusionesComponent {

  consultaObject = new ConsultaList<Discusion>();
  listDiscucion: Discusion[] = [];
  discusion: Discusion = new Discusion();

  @Input() id: number;
  @Input() tipo: string;
  constructor(
    private service: ProyectosService,
    private hucuService: HucuService,
    private msg: Msg
  ) {

  }

  ngOnInit() {
    this.consultarActividad();
  }

  guardar() {
    this.discusion.tipo = this.tipo;
    this.discusion.id_tipo = this.id;
    this.discusion.fecha_registro = new Date();
    this.hucuService.guardarDiscucion(this.discusion).subscribe(
      (res) => {
        if (res.pCodRetorno == "00000") {
          if (!this.listDiscucion.includes(this.discusion)) {
            this.listDiscucion.unshift(this.discusion);
          }
          this.discusion = new Discusion();
        } else if (res.pMensaje) {
          this.msg.successCall(res.pMensaje, 'Mensaje', null);
        } else {
          this.msg.warningCall("Lo sentimos, no se pudo guardar tu comentario", 'Mensaje', null);
        }
      });
  }

  editar(discusion: Discusion) {
    discusion.fecha_registro = new Date();
    this.hucuService.guardarDiscucion(discusion).subscribe(
      (res) => {
        if (res.pCodRetorno == "00000") {
          this.msg.successCall(res.pMensaje, 'Mensaje', null);
        } else if (res.pMensaje) {
          this.msg.warningCall(res.pMensaje, 'Mensaje', null);
        } else {
          this.msg.warningCall("Lo sentimos, no se pudo guardar tu comentario", 'Mensaje', null);
        }
      });
  }


  consultarActividad() {
    if (this.tipo && this.id) {
      this.consultaObject.bean = new Discusion();
      this.consultaObject.bean.id_tipo = this.id;
      this.consultaObject.bean.tipo = this.tipo;
      this.consultaObject.bean.nombre_usuario = "Tu ";

      this.service.consultaDiscusion(this.consultaObject).subscribe(res => { 
        if (res != null && res.list.length > 0) {
          this.listDiscucion = res.list;
        }
      });
    }
  }

}
